import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CreateManyContainerStationsMutationVariables = Types.Exact<{
  count: Types.Scalars['Int'];
  storeId: Types.Scalars['ID'];
  type_id: Types.Scalars['Int'];
}>;


export type CreateManyContainerStationsMutation = { __typename?: 'Mutation', createManyContainerStations: Array<{ __typename?: 'ContainerStation', id: string, name: string, store_id: string, epc_tag: string, item_type: { __typename?: 'ItemType', id: number, name: string, color_hex_code?: string | null, category: Types.ItemTypeCategory, epc_asset_id: number, image_url?: string | null, archived: boolean, weight: number } }> };


export const CreateManyContainerStationsDocument = gql`
    mutation CreateManyContainerStations($count: Int!, $storeId: ID!, $type_id: Int!) {
  createManyContainerStations(
    count: $count
    store_id: $storeId
    type_id: $type_id
  ) {
    id
    name
    store_id
    item_type {
      id
      name
      color_hex_code
      category
      epc_asset_id
      image_url
      archived
      weight
    }
    epc_tag
  }
}
    `;
export type CreateManyContainerStationsMutationFn = Apollo.MutationFunction<CreateManyContainerStationsMutation, CreateManyContainerStationsMutationVariables>;

/**
 * __useCreateManyContainerStationsMutation__
 *
 * To run a mutation, you first call `useCreateManyContainerStationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateManyContainerStationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createManyContainerStationsMutation, { data, loading, error }] = useCreateManyContainerStationsMutation({
 *   variables: {
 *      count: // value for 'count'
 *      storeId: // value for 'storeId'
 *      type_id: // value for 'type_id'
 *   },
 * });
 */
export function useCreateManyContainerStationsMutation(baseOptions?: Apollo.MutationHookOptions<CreateManyContainerStationsMutation, CreateManyContainerStationsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateManyContainerStationsMutation, CreateManyContainerStationsMutationVariables>(CreateManyContainerStationsDocument, options);
      }
export type CreateManyContainerStationsMutationHookResult = ReturnType<typeof useCreateManyContainerStationsMutation>;
export type CreateManyContainerStationsMutationResult = Apollo.MutationResult<CreateManyContainerStationsMutation>;
export type CreateManyContainerStationsMutationOptions = Apollo.BaseMutationOptions<CreateManyContainerStationsMutation, CreateManyContainerStationsMutationVariables>;